export interface IActions {
  // key - Action, value - devicesIds
  [key: string]: number[];
}

export enum DeviceAction {
  Assign = 'Assign',
  Unassign = 'Unassign',
  Unregister = 'Unregister',
  MarkAsReturned = 'MarkAsReturned',
  MarkAsLost = 'MarkAsLost',
  MarkAsDefective = 'MarkAsDefective',
  MarkAsAvailable = 'MarkAsAvailable',
  DeactivateSim = 'DeactivateSim',
  ActivateSim = 'ActivateSim',
  Delete = 'Delete',
}

export interface IAction {
  type: DeviceAction;
  devicesIds: number[];
}
